"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeTableListener = void 0;
var tslib_1 = require("tslib");
var renderer_class_names_1 = require("../../../core/canvas/renderer-class-names");
var frame_base_listener_1 = require("./frame-base-listener");
var ResizeTableListener = (function (_super) {
    tslib_1.__extends(ResizeTableListener, _super);
    function ResizeTableListener() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResizeTableListener.prototype.baseFrameClassName = function () {
        return renderer_class_names_1.RendererClassNames.TABLE_BORDER_LINE;
    };
    return ResizeTableListener;
}(frame_base_listener_1.FrameBaseListener));
exports.ResizeTableListener = ResizeTableListener;
